import {useEffect} from "react";
import {useParams, useNavigate} from "react-router-dom";
import {useQuery} from "@tanstack/react-query";
import {getProductByCode} from "../../api/catalog";

export default function ProductByCode() {
    const {code} = useParams<{code: string}>();
    const navigate = useNavigate();

    const {data: product, isLoading, isError} = useQuery({
        queryKey: ['productByCode', code],
        queryFn: () => getProductByCode(code!),
        enabled: !!code,
    });

    useEffect(() => {
        if (product) {
            navigate(`/catalog/item/${product.catalog_code}/${product.id}/${product.human_url}`, {replace: true});
        }
    }, [product, navigate]);

    if (isLoading) {
        return <div>Загрузка...</div>;
    }

    if (isError) {
        return <div>Ошибка загрузки продукта</div>;
    }

    return <></>;
}